<template>
	<div
		class="text-danger"
	>
		Необходимо принять Cookies
	</div>
</template>

<script>
export default {};
</script>
